<script>
  import { getContext, onMount } from 'svelte';
  import { fade, fly } from 'svelte/transition';
 
  import {SEARCH_PEOPLE} from '../../graphql/people';
  
  const client = getContext('apollo');

  import Loader from '../../components/ui/loader.html';
  import Person from './components/person.html';
  import Plus from '../../components/buttons/plus';
  import Link from '../../utils/link';
  import Search from '../../components/inputs/search';
  import LoadMore from '../../components/buttons/loadmore';

  let search = '';
  let query = client.watchQuery({ query: SEARCH_PEOPLE, variables: {search} });
  let results = {loading: true};

  function setResponse({data, loading, error, networkStatus}) {
    results = {
      loading,
      pages: data && data.people ? data.people.pages : 1,
      page: data && data.people ? data.people.page : 1,
      total: data && data.people ? data.people.total : 0,
      people: data && data.people ? data.people.docs : []
    }
  }

  const subscription = query.subscribe({
    next: nextResult => {
      setResponse(nextResult);
    },
    error: error => {
      setResponse({error, loading: false});
    }
  });

  function searchPeople() {
    query.refetch({search, page: 1});
  }

  function loadMore() {
    query.fetchMore({
      variables: {
        search,
        page: results.page + 1
      },
      updateQuery: (prev, {fetchMoreResult}) => {
        if (!fetchMoreResult) return prev;
        return Object.assign({}, prev, {
          people: {
            ...fetchMoreResult.people,
            docs: [...prev.people.docs, ...fetchMoreResult.people.docs]
          }
        });
      }
    });
  }
</script>




<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <h1>{results.total || 0} People</h1>
  </div>
  <div class="cell small-12 medium-12">
    <Search on:input={searchPeople} bind:value={search} placeholder={'Search People'}  />
  </div>
  <div class="cell small-12 medium-12">
    {#if results.loading}
      <Loader></Loader>
    {/if}
    {#if !results.loading}
      <div class="grid-x grid-margin-x small-up-1 medium-up-3">
        {#each results.people as person, i}
          <div class="cell">
            <Person person={person} />
          </div>
        {/each}
      </div>
      
    {/if}
  </div>
  <div class="cell small-12 text-center">
    {#if !results.loading && results.page !== results.pages}<LoadMore on:click={loadMore} />{/if}
  </div>
</div>
